import axios from "axios";
import { toast } from "react-toastify";
import toastOptions from "../assets/constants/toast";

let hasShownSessionExpiredToast = false;

const setupAxiosInterceptors = () => {
    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response?.status === 401 && !hasShownSessionExpiredToast) {
                hasShownSessionExpiredToast = true;
                toast.error("Votre session a expiré. Veuillez vous reconnecter.", toastOptions);

                localStorage.removeItem("session_token");

                setTimeout(() => {
                    window.location.href = "/login";
                }, 2000);
            }
            return Promise.reject(error);
        }
    );
};

export const resetSessionExpiredFlag = () => {
    hasShownSessionExpiredToast = false;
};

export default setupAxiosInterceptors;
